export function hasChildren(item: any) {
  const { items: children } = item;
  if (children === undefined) 
    return false;

  if (children.constructor !== Array) 
    return false;

  if (!children.length || children.length <= 0) 
    return false;

  return true;
}